export const lruMemoizeAsync = (fn, maxMemoSize = 30) => {
  const memo = new Map();
  const memoized = (...args) => {
    const key = JSON.stringify(args);
    if (memo.has(key)) {
      const result = memo.get(key);
      memo.delete(key);
      memo.set(key, result);
      return result;
    }
    const result = fn(...args).catch(err => {
      console.error('Memoized async function rejected', err);
      memo.delete(key);
      throw err;
    });
    if (memo.size === maxMemoSize) {
      memo.delete(memo.keys().next().value);
    }
    memo.set(key, result);
    return result;
  };
  return memoized;
};
export const lruMemoizeAsyncExceptInTests = (fn, maxMemoSize = 30) => {
  return '__hs_test_no_memoize__' in window ? fn : lruMemoizeAsync(fn, maxMemoSize);
};